import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

import styles from './item.module.css';

interface GeneralCurrencyPickerItemSignature {
  Args: {
    dropdown: { toggleDropdown: () => void };
    iconBefore?: IconName;
    onClick: () => void;
    subLabel?: string;
  };
  Blocks: {
    actions: [];
    default: [];
  };
  Element: HTMLButtonElement;
}

export default class GeneralCurrencyPickerItem extends Component<GeneralCurrencyPickerItemSignature> {
  @action handleClick(): void {
    this.args.dropdown.toggleDropdown();
    this.args.onClick();
  }

  <template>
    <button
      class="button--unstyled flex items-center gap-200 px-300 {{styles.item}}"
      type="button"
      {{on "click" this.handleClick}}
      ...attributes
    >
      {{#if @iconBefore}}
        <PrismIcon @name={{@iconBefore}} @size="small" />
      {{/if}}

      <div class="overflow-hidden py-200">
        <div class="text-300--regular text-neutral-emphasis">
          {{yield}}
        </div>
        {{#if @subLabel}}
          <p class="text-200--regular text-neutral-subdued">{{@subLabel}}</p>
        {{/if}}
      </div>

      {{#if (has-block "actions")}}
        <div class={{styles.actions}}>
          {{yield to="actions"}}
        </div>
      {{/if}}
    </button>
  </template>
}
